import React from 'react';
import { colorSet, clsx } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import {
  Avatar,
  Stepper,
  Step,
  StepLabel,
  makeStyles,
  Theme
} from '@material-ui/core';

import { Delivery, DeliveryParcel, Task, Tools } from '@carbon/icons-react';

interface Props {
  activeStep?: number;
  error?: boolean;
}

export default function BubbleStepper({
  activeStep = 1,
  error = false
}: Props) {
  const classes = useStyles({ error });

  const StepData: Array<{
    StepIcon: React.ReactNode;
    StepLabel: React.ReactNode;
  }> = [
    {
      StepIcon: <Task />,
      StepLabel: (
        <CustomizedTypography variant="caption">발주/결제</CustomizedTypography>
      )
    },
    {
      StepIcon: <Tools />,
      StepLabel: (
        <CustomizedTypography variant="caption">제조</CustomizedTypography>
      )
    },
    {
      StepIcon: <Delivery />,
      StepLabel: (
        <CustomizedTypography variant="caption">배송</CustomizedTypography>
      )
    },
    {
      StepIcon: <DeliveryParcel />,
      StepLabel: (
        <CustomizedTypography variant="caption">거래완료</CustomizedTypography>
      )
    }
  ];

  return (
    <Stepper className={classes.root} alternativeLabel>
      {StepData.map((item, index) => {
        const isActive = index + 1 === activeStep;
        return (
          <Step
            key={index}
            className={clsx(classes.step, {
              [classes.activeStep]: isActive
            })}
          >
            <StepLabel
              StepIconComponent={() => (
                <Avatar
                  className={clsx(classes.stepIcon, {
                    [classes.activeStepIcon]: isActive
                  })}
                >
                  {item.StepIcon}
                </Avatar>
              )}
            >
              {item.StepLabel}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
}

const useStyles = makeStyles<Theme, Props>(() => {
  return {
    root: {
      width: '100%',
      padding: '16px 7px 8px',
      backgroundColor: 'transparent',
      maxWidth: 416,
      margin: '0px auto',
      '& .MuiStepConnector-alternativeLabel': {
        top: 13,
        left: 'calc(-50% + 10px)',
        right: 'calc(50% + 10px)',
        '& .MuiStepConnector-lineHorizontal': {
          borderTopStyle: 'dashed',
          borderTopWidth: 2
        }
      }
    },
    step: {
      padding: 0,
      '& .MuiTypography-caption': {
        color: colorSet.gray600
      },
      '& .MuiStepLabel-label': {
        marginTop: 6
      }
    },
    activeStep: {
      '& .MuiTypography-caption': {
        color: ({ error }) => (error ? colorSet.errorMain : colorSet.primary500)
      }
    },
    stepIcon: {
      width: 28,
      height: 28,
      backgroundColor: colorSet.gray600,
      border: `1px solid ${colorSet.gray600}`,
      zIndex: 1,
      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: colorSet.gray600
      }
    },
    activeStepIcon: {
      backgroundColor: ({ error }) =>
        error ? colorSet.errorMain : colorSet.primary500,
      border: 'none',
      '& .MuiSvgIcon-root': {
        color: colorSet.gray600
      }
    }
  };
});
